// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/resources/static_data/index.ts"
);
import.meta.hot.lastModified = "1726147446104.2698";
}
// REMIX HMR END

import { TourismIndexNested, TourismRegion } from '~/types/apiTourism';
import tourism_index from './tourism_index.json';
import amenityFeaturesLocalesJson from './amenityFeaturesLocales.json';
import nullDataZuerich from '../../../public/static_api_data/zuerich/_nulldata.json';
import nullDataEyz from '../../../public/static_api_data/eyz/_nulldata.json';
import nullDataRapperswilZuerichsee from '../../../public/static_api_data/rapperswil_zuerichsee/_nulldata.json';
import { SupportedLangs } from '~/types/sys';

const tourismDataIndex = new Map<string, TourismIndexNested>();
tourism_index.forEach(idx => tourismDataIndex.set(idx.id, idx));

const amenityFeaturesLocales = new Map<string, Record<Partial<SupportedLangs>, string>>()
Object.entries(amenityFeaturesLocalesJson).forEach(fe => amenityFeaturesLocales.set(fe[0], fe[1]))



export function createNestedStructure(
    region: TourismRegion
): Record<string, TourismIndexNested[]> {

    let excluded: string[]

    if (region === "zuerich") {
        excluded = nullDataZuerich
    } else if (region === "eyz") {
        excluded = nullDataEyz
    } else if (region === "rapperswil_zuerichsee") {
        excluded = nullDataRapperswilZuerichsee
    } else {
        excluded = []
    }

    const nestedStructure: Record<string, TourismIndexNested[]> = {};
    for (const [key, tourismIndex] of tourismDataIndex.entries()) {
        if (!excluded.includes(key)) {
            const parentId = tourismIndex.parent;
            if (parentId === "0") {
                if (!nestedStructure[parentId]) nestedStructure[parentId] = [];
                nestedStructure[parentId].push(tourismIndex);
            } else {
                const parent = tourismDataIndex.get(parentId);
                if (parent) {
                    if (!parent.children) parent.children = [];
                    if (!parent.children.find((it) => it.id === key)) parent.children.push(tourismIndex);
                }
            }
        }
    }
    return nestedStructure;
}

export const createFileIndexPart = (part: TourismIndexNested[]) => {
    const outp: string[] = []
    for (const [, entry] of part.entries()) {
        if (entry.children) {
            outp.push(...createFileIndexPart(entry.children))
        } else {
            outp.push(entry.id)
        }
    }
    return outp
}


export const createFileIndex = (
    region: TourismRegion
) => {
    const nestedStructure = createNestedStructure(region)["0"]
    return createFileIndexPart(nestedStructure)
}


export const possibleAmenitiesTranslations = (amenity: string, targetlang: SupportedLangs) => {
    if (targetlang === 'en') return amenity
    const res = amenityFeaturesLocales.get(amenity)
    if (res) return res[targetlang]
    return amenity
}


export { tourismDataIndex, amenityFeaturesLocales }


export const BEHOERDEN_GREMIEN_LABEL_SHORT = [
    ["Kantonsrat", "KR"],
    ["Aufsichtskommission Bildung und Gesundheit", "ABG"],
    ["Aufsichtskommission über die wirtschaftlichen Unternehmen", "AWU"],
    ["Finanzkommission", "FIKO"],
    ["Geschäftsprüfungskommission", "GPK"],
    ["Interfraktionelle Konferenz", "IFK"],
    ["Justizkommission", "JUKO"],
    ["Kommission für Bildung und Kultur", "KBIK"],
    ["Kommission für Energie, Verkehr und Umwelt", "KEVU"],
    ["Kommission für Justiz und öffentliche Sicherheit", "KJS"],
    ["Kommission für Planung und Bau", "KPB"],
    ["Kommission für soziale Sicherheit und Gesundheit", "KSSG"],
    ["Kommission für Staat und Gemeinden", "STGK"],
    ["Kommission für Wirtschaft und Abgaben", "WAK"],
    ["Parlamentarische Untersuchungskommission Datensicherheit", "PUKDS"],
    ["Präsidium KR", "KRP"],
    ["Redaktionskommission", "REDKO"],
    ["Geschäftsleitung", "GLKR"]
]


export const GESCHAEFTE_ARTEN  =   [
    "Wahl",
    "Dringliche Interpellation",
    "Vorlage",
    "Anfrage",
    "Leistungsmotion",
    "Dringliche Anfrage",
    "Dringliches Postulat",
    "Einzelinitiative",
    "Motion",
    "Parlamentarische Initiative",
    "Behördeninitiative",
    "Geschäftsbericht",
    "Postulat",
    "Interpellation",
    "Tätigkeitsbericht",
    "Finanzmotion",
    "Rechenschaftsbericht",
    "Bericht",
    "Eintritt KR",
    "Medienmitteilung"
]